export const QuestionPage = "QuestionPage";
export const CalculatedSummaryPage = "CalculatedSummaryPage";
export const ListCollectorPage = "ListCollectorPage";
export const ListCollectorQualifierPage = "ListCollectorQualifierPage";
export const ListCollectorAddItemPage = "ListCollectorAddItemPage";
export const ListCollectorConfirmationPage = "ListCollectorConfirmationPage";
